// extracted by mini-css-extract-plugin
export default {"libraryIconStack":"LibraryIconStack-module__libraryIconStack_E6__E","mobile-ui":"mobile-ui","remainingCount":"LibraryIconStack-module__remainingCount_EC3Ar"};